define.alias("shared/utils/firebase", "settings/utils/firebase");